import React, { useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, ArrowLeftIcon, XIcon, ClockIcon, TrendingUpIcon } from 'lucide-react';
export function Search() {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const RECENT_SEARCHES = ['stand up comedy', 'office pranks', 'StandUpSammy', 'dad jokes'];
  const TRENDING_TOPICS = ['SNL highlights', 'crowd work', 'roast battles', 'funny animals'];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search/results?q=${encodeURIComponent(query)}`);
    }
  };
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-511">
      {/* Search Header */}
      <div className="px-4 pt-6 pb-4 flex items-center gap-3 border-b border-border" data-id="element-512">
        <button onClick={() => navigate(-1)} className="text-white hover:text-softGray transition-colors" data-id="element-513">
          <ArrowLeftIcon size={24} data-id="element-514" />
        </button>
        <form onSubmit={handleSubmit} className="flex-1 relative" data-id="element-515">
          <SearchIcon size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-softGray" data-id="element-516" />
          <input autoFocus type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search..." className="w-full bg-surface border border-border rounded-full py-2 pl-10 pr-10 text-sm text-white placeholder:text-softGray focus:outline-none focus:border-primary" data-id="element-517" />
          {query && <button type="button" onClick={() => setQuery('')} className="absolute right-3 top-1/2 -translate-y-1/2 text-softGray hover:text-white" data-id="element-518">
              <XIcon size={16} data-id="element-519" />
            </button>}
        </form>
      </div>

      <div className="flex-1 overflow-y-auto no-scrollbar p-4" data-id="element-520">
        {/* Recent Searches */}
        {!query && <div className="mb-8" data-id="element-521">
            <div className="flex items-center justify-between mb-4" data-id="element-522">
              <h2 className="text-white font-poppins font-bold" data-id="element-523">Recent</h2>
              <button className="text-softGray text-xs font-medium hover:text-white" data-id="element-524">
                Clear all
              </button>
            </div>
            <div className="space-y-4" data-id="element-525">
              {RECENT_SEARCHES.map(term => <div key={term} className="flex items-center justify-between group cursor-pointer" onClick={() => setQuery(term)} data-id="element-526">
                  <div className="flex items-center gap-3 text-softGray group-hover:text-white transition-colors" data-id="element-527">
                    <ClockIcon size={18} data-id="element-528" />
                    <span className="text-sm" data-id="element-529">{term}</span>
                  </div>
                  <button className="text-softGray hover:text-white" data-id="element-530">
                    <XIcon size={16} data-id="element-531" />
                  </button>
                </div>)}
            </div>
          </div>}

        {/* Trending */}
        {!query && <div data-id="element-532">
            <div className="flex items-center gap-2 mb-4" data-id="element-533">
              <TrendingUpIcon className="text-neonOrange" size={20} data-id="element-534" />
              <h2 className="text-white font-poppins font-bold" data-id="element-535">
                Trending Topics
              </h2>
            </div>
            <div className="space-y-4" data-id="element-536">
              {TRENDING_TOPICS.map((topic, i) => <div key={topic} className="flex items-center gap-4 cursor-pointer group" onClick={() => setQuery(topic)} data-id="element-537">
                  <span className={`text-sm font-bold w-4 text-center ${i < 3 ? 'text-primary' : 'text-softGray'}`} data-id="element-538">
                    {i + 1}
                  </span>
                  <span className="text-white text-sm group-hover:text-primary transition-colors" data-id="element-539">
                    {topic}
                  </span>
                </div>)}
            </div>
          </div>}

        {/* Search Suggestions (Mocked) */}
        {query && <div className="space-y-4" data-id="element-540">
            <div className="flex items-center gap-3 text-white cursor-pointer" onClick={handleSubmit} data-id="element-541">
              <SearchIcon size={18} className="text-primary" data-id="element-542" />
              <span className="text-sm font-medium" data-id="element-543">Search for "{query}"</span>
            </div>
            {['videos', 'creators', 'hashtags'].map(suffix => <div key={suffix} className="flex items-center gap-3 text-softGray hover:text-white cursor-pointer transition-colors" onClick={() => {
          setQuery(`${query} ${suffix}`);
          handleSubmit(new Event('submit') as any);
        }} data-id="element-544">
                <SearchIcon size={18} data-id="element-545" />
                <span className="text-sm" data-id="element-546">
                  {query} {suffix}
                </span>
              </div>)}
          </div>}
      </div>
    </div>;
}